import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const ImageIcon: React.FunctionComponent<IconProps> = ({
  width = 18,
  height = 18,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={24} viewBoxHeight={24} {...rest}>
    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/ui/icon/image.icon.tsx